enum SyncProvider {
    BIMSYNC,
    ACC
}

export default SyncProvider;